import React from 'react';
import { FloatLabel } from '../../../Components';

interface AddressPartialFormProps<T> {
    values: T;
    onChange: <K extends keyof T>(field: K, value: T[K]) => void;
    onChangeNumberAddress?: (value: string) => void;
    errors?: Partial<Record<keyof T, string>>;
    dictAddressStreetLabel: string;
    dictAddressNumberLabel: string;
    dictAddressPostalLabel: string;
    dictAddressLocalityLabel: string;
    dictErrorSubmit: string;
}

const AddressApplicantPartialForm = <
    T extends {
        addressStreetApplicant: string;
        addressNumberApplicant: string;
        addressPostalApplicant: string;
        addressLocalityApplicant: string;
    },
>({
    values,
    onChange,
    onChangeNumberAddress,
    errors,
    dictAddressStreetLabel,
    dictAddressNumberLabel,
    dictAddressPostalLabel,
    dictAddressLocalityLabel,
    dictErrorSubmit,
}: AddressPartialFormProps<T>) => {
    return (
        <div className="row prime-form-group">
            <div className="col-10">
                <FloatLabel
                    active={!!values.addressStreetApplicant}
                    label={dictAddressStreetLabel}
                    labelId="addressStreetApplicant"
                >
                    <input
                        type="text"
                        name="addressStreetApplicant"
                        value={values.addressStreetApplicant}
                        onChange={(e) =>
                            onChange('addressStreetApplicant', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressStreetApplicant && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-2">
                <FloatLabel
                    active={!!values.addressNumberApplicant}
                    label={dictAddressNumberLabel}
                    labelId="addressNumberApplicant"
                >
                    <input
                        type="text"
                        name="addressNumberApplicant"
                        value={values.addressNumberApplicant}
                        onChange={(e) =>
                            onChangeNumberAddress
                                ? onChangeNumberAddress(e.target.value)
                                : onChange(
                                      'addressNumberApplicant',
                                      e.target.value
                                  )
                        }
                    />
                </FloatLabel>
                {errors?.addressNumberApplicant && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-4">
                <FloatLabel
                    active={!!values.addressPostalApplicant}
                    label={dictAddressPostalLabel}
                    labelId="addressPostalApplicant"
                >
                    <input
                        type="text"
                        name="addressPostal"
                        value={values.addressPostalApplicant}
                        onChange={(e) =>
                            onChange('addressPostalApplicant', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressPostalApplicant && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-8">
                <FloatLabel
                    active={!!values.addressLocalityApplicant}
                    label={dictAddressLocalityLabel}
                    labelId="addressLocality"
                >
                    <input
                        type="text"
                        name="addressLocality"
                        value={values.addressLocalityApplicant}
                        onChange={(e) =>
                            onChange('addressLocalityApplicant', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressLocalityApplicant && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddressApplicantPartialForm;
